import { gql } from '@apollo/client';

export const QUERY = gql`
  query RegistrationFormVisibilityRules($formId: Int!) {
    registrationFormVisibilityRules(formId: $formId) {
      answerToMatch
      chainingComparison
      comparison
      formFieldId
      id
      order
      targetFormFieldId
    }
  }
`;
